import {inject, Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router, CanActivateFn, CanDeactivateFn} from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Observable, Subject } from 'rxjs';
import { ReportPageInterface } from '../interface';
import { PageNumbers } from '../model/Enums';
import { InvalidFormPopupComponent } from '../pages/report';
import { ReportService } from '../services';

let invalidFormDialog: BsModalRef;

export const canDeactivateFormValidationGuard: CanDeactivateFn<ReportPageInterface> = async (component: ReportPageInterface,
                                                                      currentRoute: ActivatedRouteSnapshot,
                                                                      currentState: RouterStateSnapshot,
                                                                      nextState?: RouterStateSnapshot): Promise<boolean> => {
  const reportService = inject(ReportService);
  const router = inject(Router);

  // for handled back key
  if (nextState.url.startsWith("/report/") && nextState.url.split('/').filter(itm => itm).length == 2) {
    router.navigateByUrl('/dashboard');
    return true;
  }

  if (nextState.url.startsWith("/report/")) {
    let currentUrl = currentState.url;
    if (currentUrl.lastIndexOf('/') > 0)
      currentUrl = currentUrl.substring(currentUrl.lastIndexOf('/') + 1);

    reportService.addInvalidStage(reportService.getStageNumber(currentUrl), component.isFormValid(), component.canBeSkipped());

    // this is for remove hide page stage
    if (reportService.invalidStages.some(el => el == PageNumbers.RENT_DETAILS || el == PageNumbers.MANAGER_SALARY || el == PageNumbers.REPLACEMENT_SALARY)) {
      reportService.spliceStage();
    }

    let nextUrl = nextState.url;
    if (nextUrl.lastIndexOf('/') > 0)
      nextUrl = nextUrl.substring(nextUrl.lastIndexOf('/') + 1);


    if (reportService.invalidStages.find(el => el < reportService.getStageNumber(nextUrl))) {
      showInvalidPopup();
      return false;
    }


    // Checking if Route goes "Forward" on Report
    if (reportService.getStageNumber(nextUrl) > reportService.getStageNumber(currentUrl)) {

      if (!component.canBeSkipped()) { // check skippable

        if (!component.isFormValid()) {
          // Show Form Invalid Popup
          showInvalidPopup();
        } else { // Form is Valid
          return true;
        }
      } else {
        return true;
      }

    } else {
      return true;
    }

  } else {
    return true;
  }

}

const showInvalidPopup = () => {
  const modalService = inject(BsModalService);
  invalidFormDialog = modalService.show(InvalidFormPopupComponent);
  const confirmSubject = new Subject<boolean>();
  invalidFormDialog.content.subject = confirmSubject;
  confirmSubject.subscribe(() => {
    return false;
  });
}

